"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/fontAwesomeV6Icon/index.ts
var fontAwesomeV6Icon_exports = {};
__export(fontAwesomeV6Icon_exports, {
  default: () => FontAwesomeV6Icon_default,
  kitIcons: () => kitIcons
});
module.exports = __toCommonJS(fontAwesomeV6Icon_exports);

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/fontAwesomeV6Icon/constants/index.ts
var kitIcons = /* @__PURE__ */ new Set([
  "ai-bot-regular",
  "ai-bot-solid",
  "ai-head-regular",
  "ai-head-solid",
  "ai-locked",
  "clever",
  "click-to-continue-down",
  "click-to-continue-up",
  "connected-level",
  "duotone-solid-message-question-circle-exclamation",
  "solid-bars-magnifying-glass",
  "solid-flask-sparkle",
  "solid-gear-pen",
  "solid-pen-sparkle",
  "solid-thumbtack-slash",
  "text-speech",
  "text-speech-pause"
]);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  kitIcons
});
//# sourceMappingURL=index.js.map